export default __webpack_public_path__ + "static/media/drag-dots.2b581bb6.svg";